module.exports = __webpack_public_path__ + "static/residential-services-6aa0024d139dd06ff929b7db40b5adf5.png";